"use client";
import { APP_ROUTES } from "~/constants/appRoutes";
import { QUIZ_CATEGORIES } from "~/constants/questionnaire";
import type { SurveyData } from "~/types/Survey";
import useFlag from "~/hooks/useFlag";
import { LIBIDA_QUIZ_REDESIGN } from "~/constants/flags";

import Quiz from "~/componentsDS/Quiz";
import QuizRedesign from "~/componentsDS/QuizRedesign";

type Props = {
    initialSurveyData?: SurveyData | null;
    redesignedInitialSurveyData?: SurveyData | null;
};

const PageContent = ({ initialSurveyData, redesignedInitialSurveyData }: Props) => {
    const isQuizRedesign = useFlag(LIBIDA_QUIZ_REDESIGN);

    return isQuizRedesign ? (
        <QuizRedesign
            category={QUIZ_CATEGORIES.LIBIDA}
            redirectURL={APP_ROUTES.PQP_LIBIDA}
            initialSurveyData={redesignedInitialSurveyData}
            startButtonText="Yes, I’m ready to start"
        />
    ) : (
        <Quiz
            category={QUIZ_CATEGORIES.LIBIDA}
            redirectURL={APP_ROUTES.PQP_LIBIDA}
            initialSurveyData={initialSurveyData}
        />
    )
};

export default PageContent;
